import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "year-groups",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "year-groups-chunk" */ "./components"),
      import(
        /* webpackChunkName: "yearGroupManager" */ "./modules/YearGroupModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const Component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "yearGroupManager",
        reducer,
      });
      return Component;
    })
  ),
});
